<template>
  <div class="container-fluid">
    <div class="row">
      <!-- product list -->
      <div class="col-md-6">
        <md-card class="panel-index">
          <md-card-content>
            <input type="text" id="f10" class="form-control searchtable" v-bind:placeholder="$t('Қидирув') + '(F10)'"
              v-model="filter" ref="focusedToProduct" @input="Productlistfolder(sklad_id,parent)"
              data-layout="numeric" />
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="column1"></th>
                  <th style="width: 44%;">{{ $t("Номи") }}</th>
                  <th class="column3">{{ $t("Қолдиқ") }}</th>
                  <th class="column3">{{ $t("Чакана") }} {{$t('Нарх')}}</th>
                  <th class="column3">{{$t('Улгуржи')}} {{$t('Нарх')}}</th>
                </tr>
              </thead>
              <tbody>
                <VueAutoVirtualScrollList :totalHeight="800" :defaultHeight="25" class="virtual"
                  style="width: 100%; height: calc(100vh - 110px)!important;">
                  <tr>
                    <span class="cursor" @dblclick="Productlistfolder(sklad_id,parent)">
                      <td class="column1">
                        <b-icon icon="arrow-left"></b-icon>
                      </td>
                      <td style="width: 45%;">
                        <button type="button" class="atable gohome">
                          ..
                        </button>
                      </td>
                    </span>
                    <td class="column3"></td>
                    <td class="column3"></td>
                  </tr>
                  <tr v-for="(item, index) in filteredProduct" :style="{ height: `${index / 1000 + 10}px` }"
                    :key="index" @dblclick="ShowModal(item)" v-b-toggle="['collapse-'+item.id]"
                    :class="item.is_folder == true ? 'folderyellow' : ''">
                    <td class="column1">
                      <b-icon v-if="item.is_folder==true" icon="folder-fill"></b-icon>
                    </td>
                    <td style="width: 45%;">
                      <button type="button" class="atable" style="text-align:left!important;">
                        {{ item.extra_name }}
                      </button>
                    </td>
                    <td class="column3 kol">
                      <button type="button" class="noborder" v-if="item.is_folder!=true">
                        {{ item.balance | numFormat3 }}
                      </button>
                    </td>
                    <td class="column3 kol">
                      <button type="button" class="noborder" v-if="item.price_register">
                        {{ item.price_register.chakana_price | numFormat }}
                      </button>
                    </td>
                    <td class="column3 kol">
                      <button type="button" class="noborder" v-if="item.price_register">
                        {{ item.price_register.optom_price | numFormat }}
                      </button>
                    </td>
                  </tr>
                </VueAutoVirtualScrollList>
              </tbody>
            </table>
          </md-card-content>
        </md-card>
      </div>
      <!-- panel product list -->
      <div class="col-md-6">
        <div class="row mt-2">
          <div class="col-md-3 pl-0">
            <button type="button" class="btn btn-success btn-block" @click="AddFolder()">
              <b-icon icon="folder-plus"></b-icon>
              Папка
            </button>
          </div>
          <div class="col-md-9 pl-0">
            <input type="text" id="f11" class="form-control block" :placeholder="$t('Қидирув') + '(F11)'"
              v-model="secondInput" />
          </div>
        </div>
        <md-card class="panel-product">
          <md-card-content>
            <table class="table table-bordered">
              <thead style="width: calc(100% - 18px)!important;">
                <tr>
                  <th class="column1"></th>
                  <th style="width: 44%;">{{ $t("Номи") }}</th>
                  <th class="column3">{{ $t("Ранг") }}</th>
                  <th class="column1"></th>
                </tr>
              </thead>
              <tbody>
                <VueAutoVirtualScrollList :totalHeight="800" :defaultHeight="25" class="virtual"
                  style="width: 100%; height: calc(100vh - 110px)!important;">
                  <tr>
                    <span class="cursor" @dblclick="Folderlist(sklad_id,parent)">
                      <td class="column1">
                        <b-icon icon="arrow-left"></b-icon>
                      </td>
                      <td style="width: 45%;">
                        <button type="button" class="atable gohome">
                          ..
                        </button>
                      </td>
                    </span>
                    <td class="column3"></td>
                    <td class="column1"></td>
                  </tr>
                  <tr v-for="(item, index) in folder" :style="{ height: `${index / 1000 + 10}px` }" :key="index"
                    v-b-toggle="['collapse-'+item.id]" @dblclick="Folderlist(sklad_id,item.id)"
                    :class="item.folder_name !== null ? 'folderyellow' : ''">
                    <td class="column1">
                      <b-icon v-if="item.folder_name !== null" icon="folder-fill"></b-icon>
                    </td>
                    <td style="width: 45%;">
                      <button type="button" class="atable" style="text-align:left!important;">
                        {{ item.folder_name !== null ? item.folder_name : item.product.extra_name }}
                      </button>
                    </td>
                    <td class="column3 kol">
                      <div :style="'background-color:'+item.colour" class="color-box" v-if="item.colour != null">
                      </div>
                    </td>
                    <td class="column1">
                      <b-icon icon="trash" variant="danger" font-scale="1" @click="DeleteFolder(item.id)"></b-icon>
                      <b-icon icon="pencil" v-if="item.folder_name !== null" variant="primary" font-scale="1"
                        @click="Getbyid(item.id)"></b-icon>
                    </td>
                  </tr>
                </VueAutoVirtualScrollList>
              </tbody>
            </table>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <b-modal id="modal-panel" hide-footer size="xs" @shown="Focus" @hidden="Hide()">
      <form>
        <md-card>
          <md-card-content>
            <div class="row">
              <!-- product -->
              <div class="col-md-12">
                <label>Товар</label>
                <input type="text" ref="focused" v-if="product != null" v-model="product.extra_name"
                  class="form-control" />
              </div>
              <!-- papka -->
              <div class="col-md-12">
                <label>{{ $t("Гурух") }}</label>
                <v-select v-if="product != null" :clearable="true" class="md-input" :options="folder"
                  v-model="product.parent_id" :reduce="folder_name => folder_name.id" label="folder_name">
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      {{ $t("бўйича маьлумот йўқ") }}
                    </template>
                    <em style="opacity: 0.5;" v-else>{{
                      $t("Маьлумот йўқ")
                      }}</em>
                  </template>
                </v-select>
              </div>
              <!-- color -->
              <div class="col-md-12">
                <label>{{ $t("Ранг") }}</label>
                <input type="color" class="form-control" v-if="product != null" v-model="product.colour">
              </div>
              <!-- save button -->
              <div class="col-md-2">
                <button type="button" @click="AddProduct()" :disabled="product_disable" class="btn btn-success mt-2">{{
                  $t("Сақлаш") }}</button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </b-modal>
    <b-modal id="modal-folder" hide-footer size="xs" @shown="Focus" @hidden="Hide()">
      <form>
        <md-card>
          <md-card-content>
            <div class="row">
              <!-- name -->
              <div class="col-md-12">
                <label>{{ $t("Номи") }}</label>
                <input type="text" ref="focused" v-model="folder_name" class="form-control" />
              </div>
              <div class="col-md-12">
                <label>{{ $t("Ранг") }}</label>
                <input type="color" class="form-control" v-model="colour">
              </div>
              <!-- papka -->
              <div class="col-md-12">
                <label>{{ $t("Гурух") }}</label>
                <v-select :clearable="true" class="md-input" :options="folder" v-model="parent_id"
                  :reduce="folder_name => folder_name.id" label="folder_name">
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      {{ $t("бўйича маьлумот йўқ") }}
                    </template>
                    <em style="opacity: 0.5;" v-else>{{
                      $t("Маьлумот йўқ")
                      }}</em>
                  </template>
                </v-select>
              </div>
              <!-- save button -->
              <div class="col-md-2">
                <button type="button" @click="AddFolderName()" :disabled="folder_disable"
                  class="btn btn-success mt-2">{{ $t("Сақлаш") }}</button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </b-modal>
    <b-modal id="modal-folderupdate" hide-footer size="xs" @shown="Focus" @hidden="Hide()">
      <form>
        <md-card>
          <md-card-content>
            <div class="row">
              <!-- name -->
              <div class="col-md-12">
                <label>{{ $t("Номи") }}</label>
                <input type="text" ref="focused" v-model="folderone.folder_name" class="form-control" />
              </div>
              <div class="col-md-12">
                <label>{{ $t("Ранг") }}</label>
                <input type="color" class="form-control" v-model="folderone.colour">
              </div>
              <div class="col-md-12">
                <label>{{ $t("Гурух") }}</label>
                <v-select :clearable="true" class="md-input" :options="folder" v-model="folderone.parent_id"
                  :reduce="folder_name => folder_name.id" label="folder_name">
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      {{ $t("бўйича маьлумот йўқ") }}
                    </template>
                    <em style="opacity: 0.5;" v-else>{{
                      $t("Маьлумот йўқ")
                      }}</em>
                  </template>
                </v-select>
              </div>
              <!-- save button -->
              <div class="col-md-2">
                <button type="button" @click="Updatefolder()" class="btn btn-success mt-2">{{ $t("Сақлаш") }}</button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </b-modal>
  </div>
</template>
<script>
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
import { print } from "../../../components/mixins/print.js";
  export default {
    components: { VueAutoVirtualScrollList },
  mixins: [print],
    data() {
      return {
        folderone: { "folder_name": "" },
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        parent: 0,
        parent_id: 0,
        filter: "",
        secondInput: "",
        products: [],
        colour: "#4a8cf7",
        product: {
          extra_name: "",
          folder_name: null,
          parent_id: 0,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          product_id: null,
          colour: "#4a8cf7"
        },
        product_disable: false,
        folder: [],
        folder_name: "",
        folder_disable: false
      }
    },
    computed: {
      filteredProduct() {
        return this.products.slice(0, 200);
      },
    },
    mounted: function () {
      let self = this;
      setTimeout(() => {
        if (self.sklad_id > 0) {
          self.Productlistfolder(self.sklad_id, self.parent);
        }
      }, 1000);

      setTimeout(() => {
        self.FocusToProduct();
      }, 100);

      $("body").keydown(function (e) {
        if (e.keyCode == 121) {
          $('#f10').focus();
          return false;
        } else if (e.keyCode == 122) {
          $('#f11').focus();
          return false;
        } else {
          return true;
        }
      });

      self.Folderlist(self.sklad_id, self.parent);
    },
    methods: {
      Productlistfolder(sklad, parent) {
        let self = this;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + parent,
          data: { sklad_id: sklad, datetime: null, keyword: keyword }
        }).then(function (response) {
          self.products = response.data;
          if (response.data.length > 0 && response.data[0].parent_id > 0) {
            axios
              .get("api/v1/product/id/" + response.data[0].parent_id)
              .then(function (response) {
                self.parent = response.data.parent_id;
              });
          }

          return false;
        });
      },
      FocusToProduct() {
        this.$refs.focusedToProduct.focus();
      },
      ShowModal(item) {
        let self = this;
        if (item.is_folder == true) {
          self.Productlistfolder(self.sklad_id, item.id);
        } else {
          self.Folderlist(self.sklad_id, self.parent);
          self.product.extra_name = item.extra_name;
          self.product.product_id = item.id;
          self.$bvModal.show('modal-panel');
        }
      },
      Focus() {
        this.$refs.focused.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          $("#f10").focus();
        }, 100);
      },
      Folderlist(sklad, parent) {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/product-panel/by-parent",
          data: {
            sklad_id: sklad,
            parent_id: parent
          }
        }).then(function (response) {
          self.folder = response.data;
        });
      },
      AddProduct() {
        let self = this;
        self.product_disable = true;
        axios({
          method: "post",
          url: "api/v1/product-panel",
          data: self.product
        }).then(function (response) {
          self.$bvModal.hide('modal-panel');

          self.product.extra_name = "";
          self.product.folder_name = null;
          self.product.parent_id = 0;
          self.product.sklad_id = parseInt(localStorage.getItem("sklad_id"));
          self.product.product_id = null;
          self.product.colour = "#4a8cf7";

          self.Folderlist(self.sklad_id, self.parent);
        });
        self.product_disable = false;
      },
      AddFolder() {
        this.$bvModal.show('modal-folder');
      },
      AddFolderName() {
        let self = this;
        self.folder_disable = true;
        axios({
          method: "post",
          url: "api/v1/product-panel",
          data: {
            folder_name: self.folder_name,
            parent_id: self.parent_id,
            sklad_id: self.sklad_id,
            product_id: null,
            colour: self.colour
          }
        }).then(function (response) {
          self.$bvModal.hide('modal-folder');
          self.folder_name = "";
          self.parent_id = 0,
            self.Folderlist(self.sklad_id, self.parent);
        });
        self.folder_disable = false;
      },
      Updatefolder() {
        let self = this;
        self.folder_disable = true;
        if (self.folderone.id != self.folderone.parent_id) {
          axios({
            method: "patch",
            url: "api/v1/product-panel/id/" + self.folderone.id,
            data: self.folderone
          }).then(function (response) {
            self.$bvModal.hide('modal-folderupdate');
            self.folderone = {};
            self.Folderlist(self.sklad_id, self.parent);
          });
          self.folder_disable = false;
        } else {
          self.$store.state.errors = self.$t("Papka bilan guruh teng bolishi mumkin emas");
          self.folderone.parent_id = 0;
        }
      },
      Getbyid(id) {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/product-panel/id/" + id,
        }).then(function (response) {
          self.$bvModal.show('modal-folderupdate');
          self.folderone = response.data;
        });
      },
      DeleteFolder(id) {
        let self = this;
        self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
              method: "delete",
              url: "api/v1/product-panel/id/" + id
            }).then(function (response) {
              self.Folderlist(self.sklad_id, self.parent);
            });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
          .catch(function () { });
      }
    }
  }
</script>
<style scoped>
  .color-box {
    width: 100% !important;
    height: 20px !important;
  }
</style>